import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { DragulaModule } from 'ng2-dragula';
import { LightboxModule } from 'ngx-lightbox';
import { AvatarComponent } from '../components/avatar/avatar.component';
import { ChatCrushComponent } from '../components/chat-item/chat-crush/chat-crush.component';
import { ChatImageComponent } from '../components/chat-item/chat-image/chat-image.component';
import { ChatInfoComponent } from '../components/chat-item/chat-info/chat-info.component';
import { ChatReactionComponent } from '../components/chat-item/chat-reaction/chat-reaction.component';
import { ChatReplyComponent } from '../components/chat-item/chat-reply/chat-reply.component';
import { ChatSnippetsComponent } from '../components/chat-item/chat-snippets/chat-snippets.component';
import { ChatTextComponent } from '../components/chat-item/chat-text/chat-text.component';
import { ChatroomItemComponent } from '../components/chatroom-item/chatroom-item.component';
import { ChatroomsListingComponent } from '../components/chatrooms-listing/chatrooms-listing.component';
import { DiscussionItemComponent } from '../components/discussion-item/discussion-item.component';
import { DiscussionsListingComponent } from '../components/discussions-listing/discussions-listing.component';
import { FavoritesListComponent } from '../components/favorites-list/favorites-list.component';
import { FooterComponent } from '../components/footer/footer.component';
import { GradientTextComponent } from '../components/gradient-text/gradient-text.component';
import { ImgPinchComponent } from '../components/img-pinch/img-pinch.component';
import { ImgRetryComponent } from '../components/img-retry/img-retry.component';
import { ProfileCardComponent } from '../components/profile-card/profile-card.component';
import { ProfilesGridComponent } from '../components/profiles-grid/profiles-grid.component';
import { ProfilesSliderComponent } from '../components/profiles-slider/profiles-slider.component';
import { UserProfileComponent } from '../components/user-profile/user-profile.component';
import { DateDifferencePipe, LongDatePipe, ShortDatePipe } from '../_helpers/date-diff.pipe';
import { RetryableImageDirective } from '../_helpers/image-retry.directive';
import { LinkyPipe } from '../_helpers/linky.pipe';
import { Nl2BrPipe } from '../_helpers/nl2br.pipe';
import { OrderByPipe } from '../_helpers/orderby.pipe';
import { ReversePipe } from '../_helpers/reverse.pipe';
import { MapboxService } from '../_services/mapbox.service';
import { AccordionModule } from './accordion/accordion.module';
import { IConfig, NgxMaskModule } from 'ngx-mask'
import { ChatRecordComponent } from '../components/chat-item/chat-record/chat-record.component';
import { TimePipe } from '../_helpers/time.pipe';
import { SanitizeHtmlPipe } from '../_helpers/sanitize.pipe';
import { WidgetMessagesSliderComponent } from '../components/widget-messages-slider/widget-messages-slider.component';
import { WidgetCardComponent } from '../components/widget-card/widget-card.component';
import { ChatVideoComponent } from '../components/chat-item/chat-video/chat-video.component';
import { SubscriptionPriceGeekComponent } from '../components/subscription-price-geek/subscription-price-geek.component';
import { SubscriptionPriceBrancheComponent } from '../components/subscription-price-branche/subscription-price-branche.component';
import { SubscriptionLinksComponent } from '../components/subscription-links/subscription-links.component';
import { SubscriptionLogoComponent } from '../components/subscription-logo/subscription-logo.component';
import { SubscriptionPayementMethodFormComponent } from '../components/subscription-payement-method-form/subscription-payement-method-form.component';

const maskConfigFunction: () => Partial<IConfig> = () => {
    return {
        validation: false,
    };
};
  
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    AccordionModule,
    LightboxModule,
    TranslateModule.forChild({}),
    RouterModule.forChild([]),
    DragulaModule.forRoot(),
    NgxMaskModule.forRoot(maskConfigFunction),
  ],
  declarations: [
    DateDifferencePipe,
    TimePipe,
    ShortDatePipe,
    LongDatePipe,
    ReversePipe,
    Nl2BrPipe,
    OrderByPipe,
    LinkyPipe,
    SanitizeHtmlPipe,
    AvatarComponent,
    ProfileCardComponent,
    UserProfileComponent,
    FooterComponent,
    ProfilesGridComponent,
    ProfilesSliderComponent,
    GradientTextComponent,
    ChatroomItemComponent,
    ChatroomsListingComponent,
    DiscussionItemComponent,
    ChatTextComponent,
    ChatSnippetsComponent,
    ChatRecordComponent,
    ChatReplyComponent,
    ChatImageComponent,
    ChatVideoComponent,
    ChatCrushComponent,
    ChatReactionComponent,
    ChatInfoComponent,
    FavoritesListComponent,
    DiscussionsListingComponent,
    ImgRetryComponent,
    ImgPinchComponent,
    WidgetMessagesSliderComponent,
    WidgetCardComponent,
    SubscriptionPriceGeekComponent,
    SubscriptionPriceBrancheComponent,
    SubscriptionLinksComponent,
    SubscriptionLogoComponent,
    SubscriptionPayementMethodFormComponent
  ],
  exports: [
    NgxMaskModule,
    DateDifferencePipe,
    TimePipe,
    ShortDatePipe,
    LongDatePipe,
    ReversePipe,
    Nl2BrPipe,
    OrderByPipe,
    SanitizeHtmlPipe,
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    AccordionModule,
    DragulaModule,
    LightboxModule,
    AvatarComponent,
    ProfileCardComponent,
    UserProfileComponent,
    FooterComponent,
    ProfilesGridComponent,
    ProfilesSliderComponent,
    GradientTextComponent,
    ChatroomItemComponent,
    ChatroomsListingComponent,
    DiscussionItemComponent,
    ChatTextComponent,
    ChatSnippetsComponent,
    ChatRecordComponent,
    ChatReplyComponent,
    ChatImageComponent,
    ChatVideoComponent,
    ChatCrushComponent,
    ChatReactionComponent,
    ChatInfoComponent,
    FavoritesListComponent,
    DiscussionsListingComponent,
    ImgRetryComponent,
    ImgPinchComponent,
    WidgetMessagesSliderComponent,
    WidgetCardComponent,
    SubscriptionPriceGeekComponent,
    SubscriptionPriceBrancheComponent,
    SubscriptionLinksComponent,
    SubscriptionLogoComponent,
    SubscriptionPayementMethodFormComponent
  ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [
                DateDifferencePipe,
                LinkyPipe,
                MapboxService
            ]
        };
    }
}
